export default __webpack_public_path__ + "static/media/incendie.ebd1a794.jpg";